import { gql, MutationTuple, useMutation } from '@apollo/client';

import { MFACodeSentEnum } from '../../../../constants/enums/MfaCodeSentEnum';

export const RESEND_MFA_CODE_BY_USER_ID_AND_SENT_TYPE = gql`
  mutation ResendMFACode($sentType: MFACodeSentTypeEnum!) {
    resendMFACodeByUserIdAndSentType(sentType: $sentType) {
      success
      message
      nextAttempt
    }
  }
`;

export interface IResendMFACodeByUserIdAndSentTypeParams {
  sentType: MFACodeSentEnum;
}

export interface IResendMFACodeByUserIdAndSentTypeResponse {
  resendMFACodeByUserIdAndSentType: {
    success: boolean;
    message?: string;
    nextAttempt?: string;
  };
}

export const useResendMFACodeByUserIdAndSentType = (): MutationTuple<
  IResendMFACodeByUserIdAndSentTypeResponse,
  IResendMFACodeByUserIdAndSentTypeParams
> =>
  useMutation<IResendMFACodeByUserIdAndSentTypeResponse, IResendMFACodeByUserIdAndSentTypeParams>(
    RESEND_MFA_CODE_BY_USER_ID_AND_SENT_TYPE,
  );
